import useSWR from 'swr'

const fetcher = (sku, businessUnit) => {
  const url = `${process.env.REACT_APP_QRGB_URL}?sku=${encodeURIComponent(
    sku,
  )}&businessUnit=${encodeURIComponent(businessUnit)}`
  return fetch(url).then((response) =>
    response.json().then((data) => {
      if (!response.ok) {
        throw Error(data.error || 'HTTP error')
      }
      return data
    }),
  )
}

export const useProduct = ({ sku = '', businessUnit }) => {
  const { data, error, isValidating, ...rest } = useSWR(
    sku,
    () => fetcher(sku, businessUnit),
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
    },
  )

  return {
    product: data,
    notFound: error || (!isValidating && !data),
    isLoading: (!error && !data) || isValidating,
    error,
    ...rest,
  }
}
